import { breadcrumbScript } from "@/lib/seo-jsonld";
import { createFileRoute } from "@tanstack/react-router";

const sections = [
  ["Toplanan məlumatlar", "Qeydiyyat zamanı ad, telefon nömrəsi və e-poçt ünvanınızı toplayırıq. Elan yerləşdirərkən əlavə olaraq şəhər və əlaqə məlumatları saxlanılır."],
  ["Məlumatların istifadəsi", "Məlumatlarınız yalnız xidmətin göstərilməsi, elanların dərci və dəstək məqsədilə istifadə olunur. Üçüncü tərəflərə satılmır."],
  ["Kukilər", "Sayt istifadəçi təcrübəsini yaxşılaşdırmaq üçün kukilərdən istifadə edir. Brauzer parametrlərindən onları söndürə bilərsiniz."],
  ["Təhlükəsizlik", "Bütün məlumatlar şifrələnmiş kanallar üzərindən ötürülür və qorunan serverlərdə saxlanılır."],
  ["Hüquqlarınız", "İstənilən vaxt hesabınızı və şəxsi məlumatlarınızı silmək tələbi ilə info@albazar.az ünvanına yaza bilərsiniz."],
];

export const Route = createFileRoute("/mexfilik")({
  head: () => ({
    meta: [
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { title: "Məxfilik siyasəti — Albazar.az" },
      { name: "description", content: "Albazar.az şəxsi məlumatlarınızı necə toplayır, istifadə edir və qoruyur." },
      { property: "og:title", content: "Məxfilik siyasəti — Albazar.az" },
      { property: "og:description", content: "Məlumatlarınızın qorunması qaydaları." },
    
      { property: "og:url", content: "https://albazar.az/mexfilik" },
    ],
    links: [{ rel: "canonical", href: "https://albazar.az/mexfilik" }],
    scripts: [breadcrumbScript([{ name: "Məxfilik siyasəti", path: "/mexfilik" }])],
  }),
  component: () => (
    <div className="container-x max-w-3xl py-12">
      <h1 className="text-4xl font-extrabold tracking-tight">Məxfilik siyasəti</h1>
      <div className="mt-8 space-y-6">
        {sections.map(([t, d]) => (
          <section key={t}>
            <h2 className="text-lg font-bold">{t}</h2>
            <p className="mt-2 leading-relaxed text-muted-foreground">{d}</p>
          </section>
        ))}
      </div>
    </div>
  ),
});